<syn-side-nav
  #sideNav
  (synHideEvent)="onHide.emit()"
  (synShowEvent)="onShow.emit()"
  [open]="open()"
  noFocusTrapping
  variant="sticky"
>
  @for (item of mainNavItems(); track $index) {
    <syn-nav-item
      #rla="routerLinkActive"
      [attr.divider]="item.divider ? '' : null"
      [current]="rla.isActive"
      [routerLink]="[item.route]"
      routerLinkActive="current"
    >
      <div slot="prefix" class="nav-icon-wrapper">
        <syn-icon [name]="item.icon"></syn-icon>
      </div>
      {{ translateService.translate(item.label) }}
    </syn-nav-item>
  }

  @for (item of footerNavItems(); track $index) {
    <syn-nav-item
      #rlaFooter="routerLinkActive"
      [attr.divider]="item.divider ? '' : null"
      [current]="rlaFooter.isActive"
      [routerLink]="[item.route]"
      routerLinkActive="current"
      slot="footer"
    >
      <syn-icon [name]="item.icon" slot="prefix"></syn-icon>
      {{ translateService.translate(item.label) }}
    </syn-nav-item>
  }
</syn-side-nav>
